import { Game, GameObj } from 'kaplay'
import k from '../k'
import { stats } from '../state/globals'
import gameOver from './gameOver'

k.loadSprite('robot', 'sprites/robot.png', {
  sliceX: 4,
  sliceY: 8,
  anims: {
    idle: 0,
    move: {
      from: 0,
      to: 1,
      loop: true
    },
    idleBroken: 2,
    broken: {
      from: 2,
      to: 3,
      loop: true
    },
    charge: {
      from: 4,
      to: 7,
      loop: false
    },
    jump: {
      from: 8,
      to: 11,
      loop: false,
      speed: 14
    },
    land: {
      from: 10,
      to: 8,
      loop: false,
      speed: 10
    },
    jumpBroken: {
      from: 12,
      to: 15,
      loop: false,
      speed: 14
    },
    landBroken: {
      from: 14,
      to: 12,
      loop: false,
      speed: 10
    }
  }
})

k.loadSprite('robotPlantless', 'sprites/robot.png', {
  sliceX: 4,
  sliceY: 8,
  anims: {
    idle: 16,
    move: {
      from: 16,
      to: 17,
      loop: true
    },
    idleBroken: 2 + 16,
    broken: {
      from: 2 + 16,
      to: 3 + 16,
      loop: true
    },
    charge: {
      from: 4 + 16,
      to: 7 + 16,
      loop: false
    },
    jump: {
      from: 8 + 16,
      to: 11 + 16,
      loop: false,
      speed: 14
    },
    land: {
      from: 10 + 16,
      to: 8 + 16,
      loop: false,
      speed: 14
    },
    jumpBroken: {
      from: 12 + 16,
      to: 15 + 16,
      loop: false,
      speed: 14
    },
    landBroken: {
      from: 14 + 16,
      to: 12 + 16,
      loop: false,
      speed: 14
    }
  }
})

k.loadSprite('z', 'sprites/z.png', {
  sliceX: 2,
  anims: {
    default: {
      from: 0,
      to: 1,
      speed: 0.6,
      loop: true
    }
  }
})

const moveLeft = (robot: GameObj) => {
  if (stats.isCharging) stats.isCharging = false
  if (!stats.isJumping) {
    if (stats.broken) robot.play('broken')
    else robot.play('move')
  }
  stats.isMovingLeft = true
  stats.isMovingRight = false
  robot.flipX = true
}

const moveRight = (robot: GameObj) => {
  if (stats.isCharging) stats.isCharging = false
  if (!stats.isJumping) {
    if (stats.broken) robot.play('broken')
    else robot.play('move')
  }
  stats.isMovingLeft = false

  stats.isMovingRight = true
  robot.flipX = false
}

const jump = (robot: GameObj) => {
  let pressedJump = false
  const timer = k.add([k.timer()])

  robot.onKeyPress('space', () => {
    if (robot.isGrounded()) {
      if (stats.isCharging) stats.isCharging = false
      stats.isJumping = true
      stats.durability -= 5
      stats.energy -= 1
      robot.jump(120)
      if (stats.broken) robot.play('jumpBroken')
      else robot.play('jump')
    } else {
      pressedJump = true
      timer.wait(0.1, () => (pressedJump = false))
    }
  })

  robot.onKeyDown('space', () => {
    if (!robot.isGrounded()) robot.vel.y -= k.dt() * 600
  })

  robot.onGround(() => {
    if (pressedJump) {
      robot.jump(120)
      if (stats.broken) robot.play('jumpBroken')
      else robot.play('jump')
      pressedJump = false
    }
  })

  robot.onKeyRelease('space', () => {
    if (!stats.isCharging) {
      if (stats.broken) robot.play('landBroken')
      else robot.play('land')
    }
    stats.isJumping = false
  })
}

const addKeyEvents = (robot: GameObj, partDisplay: GameObj) => {
  // move left
  robot.onKeyPress('a', () => moveLeft(robot))
  robot.onKeyRelease('a', () => (stats.isMovingLeft = false))
  robot.onKeyPress('left', () => moveLeft(robot))
  robot.onKeyRelease('left', () => (stats.isMovingLeft = false))

  // move right
  robot.onKeyPress('d', () => moveRight(robot))
  robot.onKeyRelease('d', () => (stats.isMovingRight = false))
  robot.onKeyPress('right', () => moveRight(robot))
  robot.onKeyRelease('right', () => (stats.isMovingRight = false))

  jump(robot)

  // charge
  robot.onKeyPress('x', () => {
    if (!stats.isCharging) {
      stats.isCharging = true
      stats.isMovingLeft = false
      stats.isMovingRight = false
      robot.play('charge')
    } else {
      stats.isCharging = false
      if (stats.broken) robot.play('idleBroken')
      robot.play('idle')
    }
  })

  // repair
  robot.onKeyPress('c', () => {
    if (stats.parts) {
      stats.parts -= 1
      partDisplay.text = stats.parts

      if (60 - stats.durability >= 10) stats.durability += 10
      else stats.durability = 60
    }
  })
}

export default (hasFlower: boolean, partDisplay: GameObj) => {
  const spritename = hasFlower ? 'robot' : 'robotPlantless'
  const robot = k.add([
    k.sprite(spritename),
    k.area(),
    k.pos(),
    k.anchor('center'),
    k.body(),
    k.z(1),
    k.scale(1),
    'robot'
  ])
  robot.play('idle')
  if (stats.broken) robot.play('idleBroken')

  const sleepEffect = robot.add([
    k.sprite('z'),
    k.anchor('bot'),
    k.z(-1),
    k.scale(0.5),
    k.pos(0, -10)
  ])
  sleepEffect.play('default')
  sleepEffect.hidden = true

  addKeyEvents(robot, partDisplay)

  robot.onUpdate(() => {
    k.setCamPos(robot.worldPos().x + 30, robot.worldPos().y + 25)
    if (stats.isMovingRight) {
      robot.move(k.vec2(stats.speed, 0))
      stats.energy -= 0.05
      stats.durability -= 0.01
    } else if (stats.isMovingLeft) {
      robot.move(k.vec2(-stats.speed, 0))
      stats.energy -= 0.05
      stats.durability -= 0.01
    } else if (stats.isCharging && stats.energy < 60) {
      stats.energy += 0.1
    } else if (!stats.isJumping && !stats.isCharging) {
      if (stats.broken) robot.play('idleBroken')
      else robot.play('idle')
    }

    if (stats.energy <= 0) gameOver('no more energy')
    else if (stats.durability <= 0) gameOver('broken')

    if (stats.isCharging) {
      stats.sleepy = true
      sleepEffect.hidden = false
    } else if (stats.energy <= 15 && !stats.sleepy) {
      stats.sleepy = true
      sleepEffect.hidden = false
    } else if (stats.energy > 15 && stats.sleepy) {
      stats.sleepy = false
      sleepEffect.hidden = true
    }

    if (stats.durability <= 20 && !stats.broken) stats.broken = true
    else if (stats.durability > 20 && stats.broken) stats.broken = false
  })

  return robot
}
